module.exports = __webpack_public_path__ + "static/img/14023C_R_3_20180224_LC.15f3453.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14023C_R_3_20180224_LC.png
// module id = A11k
// module chunks = 0